import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/DataTableContainer"
import DashboardLoader from "components/Loader/DashboardLoader"
import DeleteModal from "pages/Calendar/DeleteModal"
import React, { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
  useGetAllEarningsQuery,
  useDeleteEarningMutation,
} from "store/features/earning/earningManagementApi"
import EditEarningModal from "components/Modals/EditEarningModal"

const AllEarnings = () => {
  const { data: earnings, isLoading, refetch } = useGetAllEarningsQuery()
  const [deleteEarning, { isLoading: deletingEarning }] =
    useDeleteEarningMutation()

  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedEarningId, setSelectedEarningId] = useState(null)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [selectedEarning, setSelectedEarning] = useState(null)

  const showDeleteModal = id => {
    setSelectedEarningId(id)
    setDeleteModal(true)
  }

  const handleDeleteEarning = () => {
    deleteEarning(selectedEarningId)
    setDeleteModal(false)
  }

  const handleEditEarning = earning => {
    setSelectedEarning(earning)
    setEditModalOpen(true)
  }

  const handleEarningUpdate = () => {
    refetch()
    setEditModalOpen(false)
  }

  const columns = useMemo(
    () => [
      {
        header: "Project Name",
        accessorKey: "project_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Client Name",
        accessorKey: "client_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Amount",
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="fw-semibold text-success">
            ${Number(parseFloat(row.original.amount || 0).toFixed(2)).toLocaleString()}
          </div>
        ),
      },
      {
        header: "Notes",
        accessorKey: "notes",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.notes || "No notes",
      },
      {
        header: "Date",
        accessorKey: "datesystem",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          if (!row.original.datesystem) return "N/A"
          const date = new Date(row.original.datesystem)
          return date.toLocaleDateString()
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="d-flex align-items-center gap-1">
            <button
              onClick={() => handleEditEarning(row.original)}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-edit me-1"></i> Edit
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => showDeleteModal(row.original.id)}
            >
              <i className="fas fa-trash me-1"></i>
              {deletingEarning ? "Deleting..." : "Delete"}
            </button>
          </div>
        ),
      },
    ],
    [deletingEarning]
  )

  if (isLoading) {
    return <DashboardLoader />
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Earnings" breadcrumbItem="All Earnings" />

        <div className="mb-3">
          <Link to="/earnings/add" className="btn btn-primary">
            <i className="fas fa-plus me-2"></i>Add New Earning
          </Link>
        </div>

        <TableContainer
          columns={columns}
          data={earnings || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search Earnings..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteEarning}
          loader={deletingEarning}
          onCloseClick={() => setDeleteModal(false)}
        />

        {selectedEarning && (
          <EditEarningModal
            isOpen={editModalOpen}
            toggle={() => setEditModalOpen(false)}
            earning={selectedEarning}
            onEarningUpdate={handleEarningUpdate}
          />
        )}
      </div>
    </div>
  )
}

export default AllEarnings
